import { createSelector } from 'reselect'

export const getUser = (state) => state.session.user
export const getUserId = state => state.session.user.userId
export const isLogin = (state) => state.session.isLogin
export const isLoadSession = (state) => state.session.load
export const isError = (state) => state.session.error
export const messageError = (state) => state.session.messageError